module.exports = __webpack_public_path__ + "static/media/Story_2-min.060dbf5b.jpg";